import {
    EnrichmentPipe,
    isToggleOn,
    PulseEvent,
    PulseEventMessage,
    TrackerConfigurations,
} from '@pulse/common';
import { LegacySourceService } from '../services';

export class LegacySourcePipe implements EnrichmentPipe<PulseEventMessage> {
    constructor(
        private sourceService: LegacySourceService,
        private config: TrackerConfigurations,
    ) {}

    enrich(message: PulseEventMessage): PulseEventMessage {
        if (!isToggleOn(this.config.eventEnrichment, 'legacy_source')) {
            return message;
        }

        const event: PulseEvent = { ...message.data };

        if (typeof event.data !== 'object' || event.data === null) {
            event.data = {};
        }

        const currentSource = event?.data?.['source'];
        const shouldOverride =
            currentSource === true ||
            (typeof currentSource === 'string' && currentSource.toLowerCase() === 'true');

        if (shouldOverride) {
            const source = this.sourceService.getSource();
            event.data['source'] = source;
        } else if (typeof currentSource !== 'undefined' && typeof currentSource !== 'string') {
            event.data['source'] = JSON.stringify(currentSource) || '';
        }

        message.data = event;

        return message;
    }
}
